<template>
  <FC2
    v-bind="$props"
    :id="id"
    :label="label"
    :height="height"
    :textarea="textarea"
    :bb="bb"
    :valued="valued"
    fcType="fc2-textfield"
  >
    <v-menu
      v-if="showHtmlPopup"
      open-on-hover
      bottom
      left
      offset-y
      max-width="768"
    >
      <input
        slot="activator"
        v-if="!textarea"
        class="fc-control"
        :class="tf2Classes"
        ref="fc-control"
        :type="textinputType"
        :inputmode="inputmode"
        :pattern="textinputPattern"
        :name="id"
        :id="idC"
        :disabled="disabled"
        :required="required"
        :value="value"
        :title="value"
        :placeholder="placeholderC"
        :autocomplete="autocomplete"
        @change="(e) => emit('change', e)"
        @click="(e) => this.$emit('click', e)"
        @input="(e) => emit('input', e)"
        @blur="onBlur"
        @keyup="(e) => emit('keyup', e)"
        :style="getFCControlStyle()"
      />
      <textarea
        slot="activator"
        v-else
        class="fc-control"
        :class="tf2Classes"
        ref="fc-control"
        :type="textinputType"
        :inputmode="inputmode"
        :pattern="textinputPattern"
        :name="id"
        :id="idC"
        :disabled="disabled"
        :required="required"
        :value="value"
        :title="value"
        :placeholder="placeholderC"
        @change="(e) => emit('change', e)"
        @click="(e) => this.$emit('click', e)"
        @input="(e) => emit('input', e)"
        @blur="onBlur"
        @keyup="(e) => emit('keyup', e)"
        :style="getFCControlStyle()"
      />
      <template v-if="showHtmlPopup">
        <!-- <div
          slot="activator"
          style="position: absolute; right: 5px"
          v-if="icon && icon.length > 0"
          class="dt-icon-container"
        >
          <img
            v-if="icon && icon.length > 0"
            class="dt-icon v5 s0 fc2-hint"
            :title="hint"
            :src="`static/icons/${icon}.svg`"
            :alt="hint"
            @click="onIconClick"
          />
        </div> -->
        <div
          slot="activator"
          v-if="icon && icon.length > 0"
          style="position: absolute; right: 0px"
          class="validation-icon-container dt-icon-container s30"
        >
          <img
            style="
              background: radial-gradient(
                white,
                white 30%,
                transparent 35%,
                transparent
              );
            "
            v-if="icon && icon.length > 0"
            class="dt-icon v5 s2 fc2-hint"
            :title="hint"
            :src="`static/icons/${icon}.svg`"
            :alt="hint"
            @click="onIconClick"
          />
        </div>
      </template>
      <v-card>
        <div
          class="info-card-body"
          title="Click to copy to clipboard"
          @click="onPopupBodyClick"
        >
          <div v-html="popup"></div>
        </div>
      </v-card>
    </v-menu>
    <template v-else>
      <input
        v-if="!textarea"
        class="fc-control"
        :class="tf2Classes"
        ref="fc-control"
        :type="textinputType"
        :inputmode="inputmode"
        :pattern="textinputPattern"
        :name="id"
        :id="idC"
        :disabled="disabled"
        :required="required"
        :value="value"
        :title="value"
        :placeholder="placeholderC"
        :autocomplete="autocomplete"
        @change="(e) => emit('change', e)"
        @click="(e) => this.$emit('click', e)"
        @input="(e) => emit('input', e)"
        @blur="onBlur"
        @keyup="(e) => emit('keyup', e)"
        :style="getFCControlStyle()"
      />
      <textarea
        v-else
        class="fc-control"
        :class="tf2Classes"
        ref="fc-control"
        :type="textinputType"
        :inputmode="inputmode"
        :pattern="textinputPattern"
        :name="id"
        :id="idC"
        :disabled="disabled"
        :required="required"
        :value="value"
        :title="value"
        :placeholder="placeholderC"
        @change="(e) => emit('change', e)"
        @click="(e) => this.$emit('click', e)"
        @input="(e) => emit('input', e)"
        @blur="onBlur"
        @keyup="(e) => emit('keyup', e)"
        :style="getFCControlStyle()"
      />
    </template>
    <template v-if="!showHtmlPopup">
      <div
        v-if="icon && icon.length > 0"
        style="position: absolute; right: 0px"
        class="validation-icon-container dt-icon-container s30"
      >
        <img
          style="
            background: radial-gradient(
              white,
              white 30%,
              transparent 35%,
              transparent
            );
          "
          v-if="icon && icon.length > 0"
          class="dt-icon v5 s2 fc2-hint"
          :title="hint"
          :src="`static/icons/${icon}.svg`"
          :alt="hint"
          @click="onIconClick"
        />
      </div>
    </template>
    <div
    @click="getType"
      :style="{position: 'absolute',cursor:'pointer', right:showValidationIcons? '20px':'0px'}"
      v-if="type=='password'"
      class="validation-icon-container dt-icon-container s30"
    >
        <!-- <img src="/static/icons/eye.svg" alt="eye" style="height: 100%;"/> -->
      <img  src="static/icons/eye.svg"  v-if="!showText" class="dt-icon v5 s2 fc2-hint nohover"/>
        <!-- <img src="/static/icons/eye-slash.svg" alt="eye" style="height: 100%;"/> -->
      <img  src="static/icons/eye-slash.svg" v-if="showText" style="" class="dt-icon v5 s2 fc2-hint nohover"/>
    </div>
    <div
      style="position: absolute; right: 0px"
      v-if="showValidationIcons"
      class="validation-icon-container dt-icon-container s30"
    >
      <img
        style="
          background: radial-gradient(
            white,
            white 30%,
            transparent 35%,
            transparent
          );
        "
        v-if="validationResult.valid"
        class="dt-icon v5 s2 fc2-hint nohover"
        :title="'Valid'"
        :src="
          validationIconBG == 'transparent'
            ? `static/icons/textbox-complete.svg`
            : `static/icons/textbox-complete-bg-white.svg`
        "
      />
      <img
        v-else
        style="
          background: radial-gradient(
            white,
            white 30%,
            transparent 35%,
            transparent
          );
        "
        class="dt-icon v5 s2 fc2-hint nohover"
        :title="validationResult.errorMessages"
        :src="`static/icons/textbox-incomplete.svg`"
        :alt="validationResult.errorMessages"
      />
    </div>
    <div
      v-if="!textarea && overflowIndicator && isOverflown"
      class="overflow-indicator"
      :title="value"
    >
      <div class="textfield-fade-out"></div>
      <img
        :style="{
          margin: `0px`,
          height: '100%',
        }"
        :src="`static/icons/overflow-indicator.svg`"
      />
    </div>
    <div v-if="postFixExists" class="postfix">
      {{ postfixText }}
    </div>
    <div
      v-if="placeholderHTMLVisibility"
      @click="onPlaceholderHTMLClick"
      class="fc-control placeholderHTML"
      :style="getFCPlaceholderHTMLStyle()"
    >
      <slot name="placeholderHTML"></slot>
    </div>
  </FC2>
</template>

<script>
import { NotificationService } from "../../dt-plugins/notification/notification.service";
import { isOverflown, toSnakeCase, uuidv4 } from "../../utility";
import FC2, { FC2PropTypes, ControlPropTypes } from "../fc2/fc2";
import { FC2CommonProps } from "../fc2/fc2.vue";
import { FC2Mixin } from "../fc2/index";
import { ValidatorMixin } from "./validator.mixin";

export default {
  components: {
    FC2,
  },
  props: {
    ...FC2PropTypes,
    ...FC2CommonProps,
    type: {
      type: String,
      default: "text",
    },
    placeholderHTML: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: "off",
    },
  },
  mixins: [FC2Mixin(), ValidatorMixin()],
  watch: {
    value: {
      immediate: true,
      handler(to, from) {
        this.runDOMLogic();
      },
    },
  },
  mounted: function () {},

  data: function () {
    return {
      _id: uuidv4(),
      isOverflown: false,
      show: false,
      showText:false,
      placeholderHTMLFlag: true,
    };
  },
  computed: {
    placeholderC: function () {
      return this.placeholder ? this.placeholder : this.label;
    },
    idC: function () {
      return this.id ? this.id : `${toSnakeCase(this.label)}_${this._id}`;
    },
    textinputType() {
      // return this.type;
      // switch (this.type) {
      //   case "number":
      //   case "percent":
      //     return "text";
         
      //   default:
      //     return this.type;
      // }

      if(this.type=='number'||this.type=='percent' ){
        return 'text';
      }
      else if(this.showText && this.type=='password'){
        return 'text';
      }
      else if(!this.showText && this.type=='password' ){
        return 'password';
      }
      else return this.type
    },
    inputmode() {
      switch (this.type) {
        case "number":
        case "percent":
          return "decimal";
        default:
          return "text";
      }
    },
    textinputPattern() {
      switch (this.type) {
        case "number":
        case "percent":
          return `[+-]{0,1}[0-9]*[,\.]{0,1}[0-9]*`;

        default:
          return undefined;
      }
    },
    isPercent() {
      return this.type == "percent";
    },
    valued: function () {
      return this.value ? true : false;
    },
    placeholderHTMLVisibility: function () {
      return this.placeholderHTML && this.placeholderHTMLFlag;
    },
    tf2Classes() {
      return {
        highlight: this.highlight,
        overflown: this.isOverflown,
        "validation-icon": this.showValidationIcons,
      };
    },
    showHtmlPopup() {
      return this.popup && this.popupType == "html";
    },
    postfixText() {
      if (this.type == "percent") {
        return "%";
      } else {
        return "";
      }
    },
    postFixExists() {
      if (this.type == "percent") {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getFCControlStyle: function () {
      return {
        textAlign: this.ta || "left",
        width: "var(--fc2-cw)",
        opacity: this.placeholderHTML
          ? this.placeholderHTMLVisibility
            ? 0
            : 1
          : undefined,
        cursor: this.popup && this.popupType == "html" ? "pointer" : "",
        ...(this.postFixExists
          ? {
              paddingRight:"13px",
            }
          : this.type=='password' && this.showValidationIcons?{
              paddingRight:"45px"
            }:this.type=='password'?{paddingRight:"28px",}:{}),
      };
    },
    getFCPlaceholderHTMLStyle: function () {
      return {
        textAlign: this.ta || "left",
        width: "var(--fc2-cw)",
      };
    },
    onPlaceholderHTMLClick: function () {
      if (this.disabled) {
        return;
      }

      this.placeholderHTMLFlag = false;

      this.$nextTick(() => {
        this.$refs["fc-control"]?.focus?.();
      });
    },
    getType(){
    this.showText=!this.showText; 
    },
    onBlur: function (e) {
      this.placeholderHTMLFlag = true;
      this.emit("blur", e);
    },
    onPopupBodyClick: function (event) {
      const body = event.target;

      navigator.clipboard.writeText(body.innerText).then(
        function () {
          NotificationService.showNotification({
            text: "Info copied to Clipboard",
            timeout: 1000,
          });
        },
        function (err) {
          NotificationService.showNotification({
            text: "Text could not be copied to clipboard",
            timeout: 2000,
            type: "error",
          });
        }
      );
    },
    onIconClick() {
      this.$emit("iconClick", true);
    },
    // Runs the DOM Specific Logic Hook - that is available after Values are changed
    runDOMLogic() {
      // console.log({ "runDOMLogic text-field-2.vue:357": 1 });
      this.$nextTick(() => {
        // console.log(
        //   "isOverflown",
        //   this.$refs["fc-control"],
        //   isOverflown(this.$refs["fc-control"])
        // );
        // if (this.$refs['fc-control'])
        // if (this.id == "client_secret" && this.value == '087g436sj98s457087g436sj98s457087g436sj98s457087g436sj98s457087g436sj98s457087g436sj98s457436sj98s457087g436sj98s457087g436sj98s457087g436sj98s457') {
        //   console.error("client_secret");
        //   console.log({'text-field-2.vue:396 this.isOverflown' : this.isOverflown});
        // }
        this.isOverflown = isOverflown(this.$refs["fc-control"]);
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.fc2-textfield {
  --fc2-tf-padding: 0px 10px;
  --fc2-tf-padding-focus: 0px 10px;
  --fc2-tf-margin: 3px 3px 3px 0px;
  --fc2-tf-margin-focus: -1px 0px -1px 0px;

  --error-hover-bdc: var(--bc-accent-a5);
  --error-hover-bc: var(--bc-accent-a1);
  --error-focus-bdc: var(--bc-accent);

  min-height: var(--fc2-height);

  &.dbox1 {
    --fc2-tf-padding: 0px 10px 0px 10px !important;
    --fc2-tf-padding-focus: 0px 12px 0px 12px !important;
    --fc2-tf-margin: 3px 2px 3px 2px !important;
    --fc2-tf-margin-focus: 1px 0px 2px 0px !important;

    @-moz-document url-prefix() {
      --fc2-tf-margin-focus: 0px 0px 0px 0px !important;
    }
  }

  // .fc-control {
  //   padding: var(--fc2-tf-padding);
  //   margin: var(--fc2-tf-margin);
  // }

  .fc-control {
    padding: var(--fc2-tf-padding);
    margin: var(--fc2-tf-margin);

    min-width: 0px;

    border-radius: 4px;
    flex: 1;
    outline: none;

    background-color: var(--fc2-bc);
    color: var(--text-primary);
    border: 1px solid;
    border-color: var(--fc2-bdc);

    resize: none;
    // text-overflow: ellipsis;

    // &::before {
    //   content: "DA";
    // }

    &:hover {
      --fc2-bdc: var(--default-hover-bdc);
      --fc2-bc: var(--default-hover-bc);
     
    }

    &.highlight {
      --fc2-bdc: var(--default-hover-bdc);
      --fc2-bc: var(--default-hover-bc);
    }

    &:invalid {
      background: var(--error-hover-bc);
      &:hover {
        --fc2-bdc: var(--error-hover-bdc);
        --fc2-bc: var(--error-hover-bc);
      }

      &.highlight {
        --fc2-bdc: var(--error-hover-bdc);
        --fc2-bc: var(--error-hover-bc);
      }
      &:active,
      &:focus {
        --fc2-bdc: var(--error-focus-bdc);
      }
    }

    &:active,
    &:focus {
      --fc2-bdc: var(--default-focus-bdc);
      padding: var(--fc2-tf-padding-focus);
      margin: var(--fc2-tf-margin-focus);
      border-radius: 0px;
    }

    &::placeholder {
      color: var(--text-primary);
      opacity: 0.25;
    }

    &:disabled {
      // opacity: 0.5;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: var(--text-primary);
      opacity: 0.25;
    }

    &::-ms-input-placeholder {
      /* Microsoft Edge */
      color: var(--text-primary);
      opacity: 0.25;
    }
    &.overflown:focus {
      // padding-right: 4px;
    }
    &.overflown:not(.validation-icon):focus {
      padding-right: 10px;
    }
    &.overflown.validation-icon:focus {
      padding-right: 30px;
    }
  }
  // .fc-control.overflown:not(.validation-icon):focus {
  //   padding-right: 30px;
  // }
  .overflow-indicator {
    position: absolute;
    right: 0;
    // bottom: -5px;
    height: 100%;
    // background: linear-gradient(90deg, transparent, white);

    .textfield-fade-out {
      height: 18px;
      width: 24px;
      top: 4px;
      position: absolute;
      right: 10px;
      // background: linear-gradient(90deg,transparent,hsla(0,0%,100%,.25) 10%,hsla(0,0%,100%,.9) 30%,#fff);
      background: linear-gradient(
        90deg,
        transparent,
        var(--fc2-fade-color1) 10%,
        var(--fc2-fade-color2) 50%,
        var(--fc2-fade-color3) 80%, 
        var(--fc2-fade-color4) 100%
      );
      // background: var(--fc2-fade-color3);
      // background: linear-gradient(90deg,transparent 0%, rgba(0, 135, 255, 0.059) 10%,  rgb(240,248,255) 35%, rgb(240,248,255));
      // background: linear-gradient(90deg,transparent 0%, hsla(0, 0%, 100%, 0.25) 10%,  hsla(0, 0%, 100%, 0.8) 35%, #FFFFFF);
      // background: linear-gradient(90deg,transparent 0%, color-mod(var(--fc2-bc) tint(59%)) 10%,  rgba(0, 0, 255, 1) 35%, blue);
      // background: var(--fc2-bc);
    }
    --bc-cblue: rgba(0, 135, 255, 0.059);

    img {
      height: 100%;
    }
    // img {
    //   background: linear-gradient(90deg,transparent 15%, white 20%,#fff);
    // }
  }
  .postfix {
    height: 100%;
    display: flex;
    align-items: center;
    position: absolute;
    right: 5px;
  }
  // Poup Menu Focus Control Margin Style Fix
  & > .menu {
    flex: 1;
    .menu__activator {
      display: flex;
      height: var(--fc2-height);
      /* width: var(--fc2-cw); */
      flex-direction: column;
      display: flex;
      align-items: flex-start;

      input {
        width: calc(100% - 2px) !important;
        padding-right: 25px;
      }
    }
  }

  input.fc-control {
    transition: margin 50ms ease-in-out, padding 50ms ease-in-out,
      border-radius 50ms ease-in-out;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  textarea.fc-control {
    transition: border-radius 50ms ease-in-out;

    &:active,
    &:focus {
      // Correction Padding
      padding-top: 4px;
    }
  }

  .fc-control.placeholderHTML {
    position: absolute;
    left: calc(var(--fc2-lw) + 20px);
    width: calc(100% - (var(--fc2-lw) + 23px)) !important;
    height: calc(100% - 6px);

    transition: border-radius 50ms ease-in-out;

    &.disabled {
      --fc2-bc: hsla(0, 0%, 90%, 0.5);
    }
    &:active,
    &:focus {
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
    }
  }

  .validation-icon-container {
    z-index: 1;
    /* background: linear-gradient(
      90deg,
      hsla(0, 0%, 100%, 0.25),
      hsla(0, 0%, 100%, 1),
      hsla(0, 0%, 100%, 1)
    ); */
  }
}
</style>
